import { useSelector } from 'react-redux';
import { isAdminUser } from '../utils/authz';

/**
 * Hook สำหรับตรวจสอบสิทธิ์การใช้งาน (Permissions)
 * นำไปใช้ซ่อน/แสดงปุ่ม หรือ Component ต่างๆ ตามสิทธิ์
 */
export const usePermission = () => {
  const { userInfo } = useSelector((state) => state.auth);

  const permissions = userInfo?.permissions || [];
  // เดิมอ่าน userInfo.isAdmin ตรง ๆ ซึ่งแคบกว่าที่ด่าน route กับเมนูใช้
  // ผลคือคนแผนก EXEC ผ่านด่านเข้าหน้าได้ แต่ปุ่มในหน้าหายหมด — ดู utils/authz.js
  const isAdmin = isAdminUser(userInfo);

  // ฟังก์ชันเช็คสิทธิ์ (รองรับการเช็คหลายสิทธิ์ด้วย Array)
  const hasPermission = (requiredPermission) => {
    if (!userInfo) return false;
    if (isAdmin) return true; // Super Admin bypass

    if (Array.isArray(requiredPermission)) {
      // คืนค่า true ถ้ามีสิทธิ์ใดสิทธิ์หนึ่งใน array
      return requiredPermission.some(perm => permissions.includes(perm));
    }

    return permissions.includes(requiredPermission);
  };

  return { hasPermission, permissions };
};
